// Componente para exibir estatísticas principais do Dashboard
import React from "react";
import style from "../body-dashboard.module.css";

/**
 * Componente StatsSection - Estatísticas principais
 */
const StatsSection = ({ hectar, alto, medio, baixo }) => {
  return (
    <>
      {/* Card de hectares com infestação acima de 50% */}
      <div className={style["percentual-home"]}>
        <div className={style["text-information"]}>
          <p>Com previsão de infestação acima de 50%</p>
        </div>
        <div className={style["data-information"]}>
          <h2>{hectar.toFixed(2)}</h2>
          <h6>ha</h6>
        </div>
      </div>

      {/* Card de talhões por nível de infestação */}
      <div className={style["status-bugs"]}>
        <div className={style["text-info"]}>
          Talhões suscetíveis por nível de infestação
        </div>

        <div className={style["status-info"]}>
          <div className={style["level-status"]} style={{ borderColor: "red" }}>
            <h2>{alto}</h2>
            <h4 style={{ color: "red" }}>Alta</h4>
          </div>
          <div
            className={style["level-status"]}
            style={{ borderColor: "#FEC601" }}
          >
            <h2>{medio}</h2>
            <h4 style={{ color: "#FEC601" }}>Médio</h4>
          </div>
          <div
            className={style["level-status"]}
            style={{ borderColor: "green" }}
          >
            <h2>{baixo}</h2>
            <h4 style={{ color: "green" }}>Baixo</h4>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsSection;

